import React from 'react'

const refsCreator = refsArr =>
  refsArr.reduce((acc, ref) => {
    acc[ref.id] = React.createRef()
    return acc
  }, {})

export default refsCreator
